import { useQueryClient } from 'react-query';
import { TabNames } from 'components/inbox/constants';
import { useForm, FormProvider } from 'react-hook-form';
import useModal from 'components/remodal/v2/useModal';
import { Booking } from 'swagger/models';
import { Box } from 'components/primitives/box';
import { Text } from 'components/primitives/typography';
import { FlexCol } from 'components/primitives/flex';
import OwnerBookingActionsModal from '../../../../pages/a/bookings/[bookingId]/owner_action/[action]';
import MultiBookToggle from '../forms/MultiBookToggle';
import SubmitButton from '../forms/SubmitButton';
import { useUpdateBoatMutation } from '../blw/hooks';

interface Props {
  booking: Booking;
  actionType: 'approve';
}

const MultiBookModal = ({ booking, actionType }: Props) => {
  const queryClient = useQueryClient();

  const boatId = booking?.boat?.id;

  const methods = useForm({
    mode: 'onChange',
  });
  const { watch, handleSubmit } = methods;

  const updateBoatMutation = useUpdateBoatMutation();

  const { modal: ownerBookingActionsModal, openModal: openOwnerBookingActionsModal } = useModal(
    <OwnerBookingActionsModal booking={booking} actionType={actionType} />,
    {
      trackingName: 'owner_booking_actions_modal',
    }
  );

  const toggleBoatMultiBook = async () => {
    const multibook_enabled = watch('multibook_enabled');
    await updateBoatMutation.mutateAsync({
      boatId,
      body: {
        multibook_enabled,
      },
    });
  };

  const saveMultiBook = async () => {
    await toggleBoatMultiBook();
    queryClient.invalidateQueries(['conversationsTab', TabNames.owner]);
    queryClient.invalidateQueries(['conversationDetail', booking?.conversation_id]);

    openOwnerBookingActionsModal();
  };

  return (
    <div>
      <Box mb="1em">
        <Text fSize="18px" fWeight={700} as="h2" pr="20px">
          Accept Multiple Half-Day Rentals for One Day
        </Text>
      </Box>

      <FlexCol gap="16px" mb="20px">
        <div>1. You are no longer limited to one half-day booking per day</div>
        <div>
          2. Appear in more search results, when this feature is turned on your calendar is not blocked off after one
          half-day charter has been booked
        </div>
        <div>3. Works seamlessly with Instant Book</div>
      </FlexCol>

      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(saveMultiBook)}>
          <Box mb="2em">
            <MultiBookToggle boatId={boatId} />
          </Box>

          <SubmitButton disabled={false} additionalClasses="Button--yellow u-sizeFull">
            Continue
          </SubmitButton>
        </form>
      </FormProvider>

      {ownerBookingActionsModal}
    </div>
  );
};

export default MultiBookModal;
